/** Animation types supported by Codway buttons. Stored in DB as-is. */
export type ButtonAnimationType = "none" | "shake" | "bounce" | "pulse";

/**
 * Maps an animation type to its CSS `animation` shorthand value.
 * The keyframe names (codway-shake, codway-bounce, codway-pulse) must be
 * defined globally in each app's CSS entry point.
 * Returns `undefined` for "none" so callers can omit the property entirely.
 */
export function getButtonAnimation(
  type: ButtonAnimationType
): string | undefined {
  switch (type) {
    case "shake":
      return "codway-shake 0.6s ease-in-out 0.25s infinite";
    case "bounce":
      return "codway-bounce 1s ease-in-out 0.25s infinite";
    case "pulse":
      return "codway-pulse 1.5s ease-in-out 0.25s infinite";
    default:
      return undefined;
  }
}
